/**
 * Location cluster module
 *
 * @author Yi Liu (yliu@yext.com)
 */
goog.provide('yext.locationcluster');
goog.provide('yext.locationcluster.ClusterGuard');
goog.provide('yext.locationcluster.ClusterGuardOldStyleField');

goog.require('yext.notify');
goog.require('yext');
goog.require('yext.location.cluster.dialog.incomplete');
goog.require('yext.location.cluster.dialog.multiple');
goog.require('yext.location.helpers');

yext.locationcluster.CLUSTER_GUARDED_FIELDS = [
  'virtual.name',
  'location.gender',
  'emails',
  'location.headshot',
  'location.certifications',
  'degrees',
  'location.education_and_training',
  'languages',
  'admittingHospitals',
];

/**
 * Initialize the module
 */
yext.locationcluster.init = function() {
  var $clusterContainer = $('.js-location-cluster-box');

  yext.locationcluster.CONFIG = new yext.locationcluster.Config($clusterContainer);
  new yext.locationcluster.ClusterSidebar($clusterContainer);
};

/**
 * Checks if cluster warning dialog should be shown for the current field
 *
 * @param {string} locationFieldName The name of the location field
 * @return {boolean} Boolean value indicating if the field is a cluster guarded field
 */
yext.locationcluster.shouldShowWarningDialog = function(locationFieldName) {
  return yext.locationcluster.CLUSTER_GUARDED_FIELDS.indexOf(locationFieldName) > -1
    && (yext.locationcluster.CONFIG.isIncompleteCluster || yext.locationcluster.CONFIG.hasMultipleClusters);
};

/**
 * Parses the location IDs from DOM.
 *
 * @param {!jQuery} $container The container element of the cluster sidebar
 * @return {!Array} An array of location IDs in the cluster
 */
yext.locationcluster.parseLocations = function($container) {
  return $container.find('li').map(function() {
    return $(this).data('locationid');
  }).toArray();
};

/**
 * @param {!jQuery} $container The container element of the cluster sidebar
 * @constructor
 */
yext.locationcluster.Config = function($container) {
  this.$container = $container;

  // Flags that determine which warning dialog to show
  this.isIncompleteCluster = $container.data('isIncompleteCluster');
  this.hasMultipleClusters = $container.data('hasMultipleClusters');
  this.setAllLocationsUrl();
};

/**
 * Sets the url of updating all the locations in the cluster
 */
yext.locationcluster.Config.prototype.setAllLocationsUrl = function() {
  this.allLocationsUrl = '/s/' + yext.businessId + '/entity/edit?isClusterUpdate=true&entityIds=' + yext.locationcluster.parseLocations(this.$container).join(',');
};

/**
 * For fields that use field.js to save
 *
 * @param {yext.Field} field The location field form object
 * @constructor
 */
yext.locationcluster.ClusterGuard = function(field) {
  this.field = field;
  this.fieldOriginalAction = field.action;
  this.bindFormBeforeSubmit();
  this.bindFormAlways();
};

/**
 * Binds the beforeSubmit.field event and opens the right cluster warning dialog if necessary
 */
yext.locationcluster.ClusterGuard.prototype.bindFormBeforeSubmit = function() {
  var self = this;
  this.field.$form.on('beforeSubmit.field', function() {
    var options = {
      onUpdate: function() {
        self.submitForm();
      },
    };
    if (yext.locationcluster.CONFIG.isIncompleteCluster) {
      self.field.preventDefault();
      options.onUpdateAllSubmit = function() {
        self.updateAllLocationsInCluster();
      };
      yext.location.cluster.dialog.incomplete(options);
    } else if (yext.locationcluster.CONFIG.hasMultipleClusters) {
      self.field.preventDefault();
      yext.location.cluster.dialog.multiple(options);
    }
  });
};

/**
 * Binds the always.field event and resets the field's action
 */
yext.locationcluster.ClusterGuard.prototype.bindFormAlways = function() {
  var self = this;
  this.field.$form.on('always.field', function() {
    self.field.action = self.fieldOriginalAction;
  });
};

/**
 * Updates the action url of the field to include all the locations in the cluster
 */
yext.locationcluster.ClusterGuard.prototype.updateAllLocationsInCluster = function() {
  this.field.action = yext.locationcluster.CONFIG.allLocationsUrl;
};

/**
 * Submits the field form after closing the cluster dialog
 */
yext.locationcluster.ClusterGuard.prototype.submitForm = function() {
  if (this.field.files.length) {
    this.field.submitWithFiles();
  } else {
    this.field.submit();
  }
};

/**
 * For fields that use the old LocationEdit.js to save
 *
 * @param {string} form Location field form selector
 * @param {!Object} data The location field data used on save
 * @constructor
 */
yext.locationcluster.ClusterGuardOldStyleField = function(form, data) {
  this.form = form;
  this.data = data;
  this.url = '';
  this.openDialog();
};

/**
 * Opens the right cluster warning dialog if necessary
 */
yext.locationcluster.ClusterGuardOldStyleField.prototype.openDialog = function() {
  var self = this;
  var options = {
    onUpdate: function() {
      self.submitForm();
      self.reset();
    },
  };
  if (yext.locationcluster.CONFIG.isIncompleteCluster) {
    options.onUpdateAllSubmit = function() {
      self.updateAllLocationsInCluster();
    };
    yext.location.cluster.dialog.incomplete(options);
  } else if (yext.locationcluster.CONFIG.hasMultipleClusters) {
    yext.location.cluster.dialog.multiple(options);
  }
};

/**
 * Updates the url to include all the locations in the cluster
 */
yext.locationcluster.ClusterGuardOldStyleField.prototype.updateAllLocationsInCluster = function() {
  this.url = yext.locationcluster.CONFIG.allLocationsUrl;
};

/**
 * Submits the location field form
 */
yext.locationcluster.ClusterGuardOldStyleField.prototype.submitForm = function() {
  window.onFieldSave(this.form, this.data, undefined, undefined, undefined, undefined, this.url);
};

/**
 * Resets the url after field gets saved
 */
yext.locationcluster.ClusterGuardOldStyleField.prototype.reset = function() {
  this.url = '';
};

/**
 * @param {!jQuery} $container The container element of the cluster sidebar
 * @constructor
 */
yext.locationcluster.ClusterSidebar = function($container) {
  this.$container = $container;
  this.$locations = $container.find('.js-cluster-locations-list');
  this.timestamp = $container.data('timestamp');
  this.locationIds = yext.locationcluster.parseLocations(this.$container);

  this.bindReorderLocation();
};

/**
 * Allows cluster locations to be reordered
 */
yext.locationcluster.ClusterSidebar.prototype.bindReorderLocation = function() {
  var self = this;

  this.$locations.sortable({
    handle: '.js-reorder-cluster-location',
    axis: 'y',
    stop: function(e, ui) {
      self.updateIndices();
      // Note (dwen): Firefox sets top/left to 0 on stop, which causes the
      // image to be misaligned the next time it gets dragged. Explicitly
      // set top/left to auto to fix this.
      ui.item
        .css('top', 'auto')
        .css('left', 'auto');
    },
    containment: this.$locations,
    tolerance: 'pointer',
  });
};

/**
 * Makes an Ajax call if the order was updated.
 * @suppress {deprecated}
 */
yext.locationcluster.ClusterSidebar.prototype.updateIndices = function() {
  var self = this;
  var updatedLocationIds = yext.locationcluster.parseLocations(this.$container);
  var updated = false;
  for (var i = 0; i < updatedLocationIds.length; i++) {
    if (updatedLocationIds[i] !== this.locationIds[i]) {
      updated = true;
      break;
    }
  }
  if (updated) {
    this.locationIds = updatedLocationIds;
    $.ajax({
      url: '/s/' + yext.businessId + '/locations/updateClusterIndices',
      data: {
        locationIds: updatedLocationIds,
        timestamp: this.timestamp,
      },
      type: 'POST',
      success: function(response) {
        if (response.stale) {
          yext.location.helpers.showStaleError(self.$container);
        } else {
          self.timestamp = response.timestamp;
        }
      },
      error: function() {
        yext.notify.showError(yext.msg('There was an error while reordering cluster locations.'));
      },
    });
  }
};
